angular.module('gym.reports').controller('SendEmailVerificationController', ["$scope", "$rootScope", "$stateParams", "$modalInstance", "$timeout", "$http", "selectedContacts", "SendEmailVerificationService", function($scope, $rootScope, $stateParams, $modalInstance, $timeout, $http, selectedContacts, SendEmailVerificationService) {
  $scope.selectedContactsCount = selectedContacts != null ? selectedContacts.length : void 0;
  $scope.sendVerificationRequest = function() {
    var params;
    $scope.errors = {};
    params = {
      "ids": _.pluck(selectedContacts, 'id'),
      "message_from_gym": $scope.optionalMessage,
      "gym_id": $rootScope.gym.id
    };
    return SendEmailVerificationService.sendVerificationRequest(params, $modalInstance).then = function(response) {
      return $scope.errors = response.data.errors;
    };
  };
  return $scope.close = function() {
    return SendEmailVerificationService.close($modalInstance);
  };
}]);
